import { render, staticRenderFns } from "./browser-not-supported-warning-dialog.vue?vue&type=template&id=513daaae&scoped=true"
import script from "./browser-not-supported-warning-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./browser-not-supported-warning-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./browser-not-supported-warning-dialog.vue?vue&type=style&index=0&id=513daaae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513daaae",
  null
  
)

export default component.exports